import { Pipe, PipeTransform } from '@angular/core';
import * as momentTz from 'moment-timezone';

@Pipe({ name: 'momentTimezone' })
export class MomentTimeZonePipe implements PipeTransform {
  public transform(date: string | number | Date, format?: string): string {
    return momentTz(date).tz(momentTz.tz.guess()).format(format);
  }
}
